import { personasConstants } from './constants';

const INITIAL_STATE = { 
    persona: {},
    relatives: []
 };


export function personas(state = INITIAL_STATE, action) {
   switch (action.type) {

    case personasConstants.UPDATE_MY_RELATIVES:
      let relativesNEW = [] ;

      state.relatives.map( orig => {
        if (orig.persona_id === action.relativeID)  relativesNEW.push({...orig, ...action.relative})
          else relativesNEW.push(orig) ;
        return null;
      })
      return {
          ...state,
          relatives: relativesNEW
          };  

    case personasConstants.SHOW_PERSONA:
      return {
          ...state,
          persona: action.persona
          };  
        
          
          
    case personasConstants.ADD_RELATED:
  
      return {
          ...state,
          relatives: state.relatives.push( action.related ) 
          };  
      

    case personasConstants.REMOVE_RELATED:
        
      return {
          ...state,
          relatives: state.relatives.filter( (rel) => rel.persona_id !== action.related_id ) 
          };  
               
    case personasConstants.SHOW_RELATIVES:
      return {
          ...state,
          relatives: action.relatives
          };  

    default:
      return state
  }
}

